import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { Drawer } from "app/pages/.shared/Drawer";
import { FormattedMessage } from "react-intl";
import Button from "app/pages/.shared/form/Button";
import "./LastSearchDrawer.scss";
import LastSearchList from "app/features/SearchEngine/LastSearch/components/LastSearchList/LastSearchList";
import IconArrowLeft from "app/pages/.shared/static/icons/IconArrowLeft";

const LastSearchDrawer = ({
	isOpen,
	onClose = () => {},
	onClearHistory = () => {},
	onRemoveSearch = () => {},
	onItemClick = () => {},
	lastSearches = [],
}) => {
	return (
		<Drawer
			isOpen={isOpen}
			blockScroll
			direction={"rtl"}
			drawerClassName="last-search-drawer"
			clickAwayIgnoreComponents={[
				"last-search-drawer",
				"last-search-drawer__header",
				"last-search-drawer__list",
			]}
		>
			<header className="last-search-drawer__header">
				<div className="last-search-drawer__title">
					<IconArrowLeft onClick={onClose} />
					<Typography variant={TYPOGRAPHY_VARIANTS.XL} isBold>
						<FormattedMessage id="sdp.search.last.searches.drawer.title" />
					</Typography>
				</div>
				{lastSearches?.length >= 1 && (
					<Button
						variant="naked"
						onClick={onClearHistory}
						data-testid="last-search-remove-button"
						className="last-search-drawer__clear-button"
					>
						<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} isBold>
							<FormattedMessage id="sdp.search.last.searches.clear.button.label" />
						</Typography>
					</Button>
				)}
			</header>
			<div className="last-search-drawer__list">
				<LastSearchList
					items={lastSearches}
					onRemoveSearch={onRemoveSearch}
					onItemClick={onItemClick}
				/>
			</div>
		</Drawer>
	);
};

LastSearchDrawer.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	onClearHistory: PropTypes.func,
	onRemoveSearch: PropTypes.func,
	onItemClick: PropTypes.func,
	lastSearches: PropTypes.array,
};

export default LastSearchDrawer;
